"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userServiceSchema = void 0;
const zod_1 = require("zod");
const lingo2_models_1 = require("lingo2-models");
// Схема для UserService
exports.userServiceSchema = zod_1.z.object({
  id: zod_1.z.string(),
  title: zod_1.z.string().optional(),
  description: zod_1.z.string().optional(),
  excerpt: zod_1.z.string().optional(),
  price_tier: zod_1.z.any().optional(),
  slug: zod_1.z.string().optional(),
  // ID связанных сущностей
  cover_id: zod_1.z.string().optional(),
  author_id: zod_1.z.string().optional(),
  school_id: zod_1.z.string().optional(),
  teacher_ids: zod_1.z.array(zod_1.z.string()).optional(),
  subject_id: zod_1.z.string().optional(),
  language_id: zod_1.z.string().optional(),
  level_id: zod_1.z.string().optional(),
  // Финансовые параметры
  price: zod_1.z.number().optional(),
  currency: zod_1.z.string().optional(),
  duration: zod_1.z.number().optional(),
  discount: zod_1.z.number().optional(),
  discount_rule: zod_1.z.any().optional(),
  category_id: zod_1.z.number().optional(),
  // Медиа и метаданные
  media_url: zod_1.z.string().optional(),
  media: zod_1.z.any().optional(),
  keywords: zod_1.z.array(zod_1.z.string()).optional(),
  // Статусы и сообщения
  moderation_message: zod_1.z.string().optional(),
  promotion: zod_1.z.any().optional(),
  advertisement: zod_1.z.any().optional(),
  // Публикация и изменения
  publish_status: zod_1.z.nativeEnum(lingo2_models_1.PublishStatusEnum).optional(),
  changed_at: zod_1.z.string().optional(),
  purl: zod_1.z.string().optional(),
  // Флаги и ограничения
  hidden: zod_1.z.boolean().optional(),
  readonly: zod_1.z.boolean().optional(),
  participants_limit: zod_1.z.number().optional(),
  // Опции
  options: zod_1.z.object({
    requirements: zod_1.z.array(zod_1.z.string()).optional(),
    skills: zod_1.z.array(zod_1.z.string()).optional(),
    weekdays: zod_1.z.array(zod_1.z.nativeEnum(lingo2_models_1.WeekdaysEnum)).optional(),
    meetings_limit: zod_1.z.number().optional(),
    age_from: zod_1.z.number().optional(),
    age_to: zod_1.z.number().optional()
  }).optional(),
  // Рейтинг
  rating: zod_1.z.number().optional(),
  rating_total: zod_1.z.number().optional(),
  latest_applicable_date: zod_1.z.string().optional(),
  created_at: zod_1.z.string().optional(),
  updated_at: zod_1.z.string().optional()
})
// TODO: remove catchall, need to define all fields
.catchall(zod_1.z.any()); // для других полей
